/**
 * DirectTalk
 *  ダイレクトトークのメッセージ保存や、送信を行う。
 */

import virtualOffice from "../../api/virtualOffice"
import _             from 'lodash'

export default {
  namespaced: true,
  state: {
    wsVO: null,
    wsVOC: null,
    userList: [],
    cbList: [],
    virtualOfficeList: [],
    isVOConnectList: false,
    isVOC: false,
    roomStatus: null,
    isVirtualOfficeLoading: false,
    intervalVO: null,
    uri: null,
    uriChat: '',
    chatRooms: [],
    chatMessages: [],
    forums: [],
    articles: [],
    openingForum: null,
    // TODO: 別に入れる
    makeScenario: null,
    deleteScenario: null,
    reloadScenario: null
  },
  actions: {
    /* VOサーバーへの接続 */
    connectVirtualOfficeSV ({commit}, uri) {
      console.log('connectVirtualOfficeSV wsVO: ')
      commit('CONNECT_VO_BEGIN', uri)
    },
    /* VOサーバーの切断 */
    disconnectVirtualOfficeSV ({commit}) {
      commit('CONNECT_VO_END')
    },
    setVirtualOfficeSV ({commit}, data) {
      commit('SEND_VO', data)
    },
    sendVirtualOfficeSV ({commit}, data) {
      commit('SEND_VO_RAW', data)
    },
    // VirtualOffice API
    createVirtualOffice ({commit}, data) {
      virtualOffice.createVirtualOffice(data)
        .then((d) => {
          commit('CREATE_VO', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getVirtualOffice ({commit}, id) {
      commit('LOADING_VO', true)
      virtualOffice.getVirtualOffice(id)
        .then((d) => {
          commit('GET_VO', d.data)
          commit('LOADING_VO', false)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
          commit('LOADING_VO', false)
        })
    },
    updateVirtualOffice ({commit}, data) {
      virtualOffice.updateVirtualOffice(data)
        .then((d) => {
          console.log('updateVirtualOffice', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteVirtualOffice ({commit}, id) {
      virtualOffice.deleteVirtualOffice(id)
        .then((d) => {
          commit('DELETE_VO', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // OfficeType API
    createOfficeType ({commit}, data) {
      virtualOffice.createOfficeType(data)
        .then((d) => {
          commit('CREATE_OT', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getOfficeType ({commit}, id) {
      virtualOffice.getOfficeType(id)
        .then((d) => {
          commit('GET_OT', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateOfficeType ({commit}, data) {
      virtualOffice.updateOfficeType(data)
        .then((d) => {
          console.log('updateOfficeType', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteOfficeType ({commit}, id) {
      virtualOffice.deleteOfficeType(id)
        .then((d) => {
          commit('DELETE_OT', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // VirtualOfficeRoom API
    creatVirtualOfficeRoom ({commit}, data) {
      virtualOffice.createVirtualOfficeRoom(data)
        .then((d) => {
          commit('CREATE_VOR', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getVirtualOfficeRoom ({commit}, id) {
      virtualOffice.getVirtualOfficeRoom(id)
        .then((d) => {
          commit('GET_VOR', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateVirtualOfficeRoom ({commit}, data) {
      virtualOffice.updateVirtualOfficeRoom(data)
        .then((d) => {
          console.log('updateVirtualOfficeRoom', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteVirtualOfficeRoom ({commit}, id) {
      virtualOffice.deleteVirtualOfficeRoom(id)
        .then((d) => {
          commit('DELETE_VOR', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // TableName API
    createTableName ({commit}, data) {
      virtualOffice.createTableName(data)
        .then((d) => {
          commit('CREATE_TN', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    getTableName ({commit}, id) {
      virtualOffice.getTableName(id)
        .then((d) => {
          commit('GET_TN', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateTableName ({commit}, data) {
      virtualOffice.updateTableName(data)
        .then((d) => {
          console.log('updateTableName', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteTableName ({commit}, id) {
      virtualOffice.deleteTableName(id)
        .then((d) => {
          commit('DELETE_TN', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    async initVirtualOffice ({commit}, data) {
      return await virtualOffice.initVirtualOffice(data)
        .then((d) => {
          commit('INIT_VO', JSON.parse(d.data))
          return
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    setRoomStatus ({commit}, data) {
      commit('SET_ROOM_STS', data)
    },
    // ChatRoom API
    createChatRoom ({commit}, data) {
      return virtualOffice.createChatRoom(data)
        .then((d) => {
          commit('CREATE_CR', d.data)
          return d.data
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    getChatRoom ({commit}, id) {
      virtualOffice.getChatRoom(id)
        .then((d) => {
          commit('GET_CR', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    updateChatRoom ({commit}, data) {
      virtualOffice.updateChatRoom(data)
        .then((d) => {
          commit('UPDATE_CR', d.data)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    deleteChatRoom ({commit}, id) {
      virtualOffice.deleteChatRoom(id)
        .then((d) => {
          commit('DELETE_CR', id)
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    // ChatRoomMessage API
    getChatRoomMessage ({commit}, id) {
      return virtualOffice.getChatRoomMessage(id)
        .then((d) => {
          commit('GET_CRM', d.data)
          return
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    /* VOChatサーバーへの接続 */
    connectChatRoomSV ({commit}, uri) {
      commit('CONNECT_VOC_BEGIN', uri)
    },
    /* VOChatサーバーの切断 */
    disconnectChatRoomSV ({commit}) {
      commit('CONNECT_VOC_END')
    },
    sendChatRoomSV ({commit}, data) {
      commit('SEND_VOC', data)
    },
    //Forum 関連 Actions
    getForum ({commit}, id) {
      return virtualOffice.getForum(id)
        .then((d) => {
          if (id) commit('UPDATE_FORUM', d.data)
          else commit('SET_FORUM', d.data)
          return
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    updateForum ({commit}, data) {
      return virtualOffice.updateForum(data)
        .then((d) => {
          commit('UPDATE_FORUM', d.data)
          return
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    // Article 関連 Actions
    getArticle ({commit}, id) {
      return virtualOffice.getArticle(id)
        .then((d) => {
          if (id) commit('UPDATE_ARTICLE', d.data)
          else commit('SET_ARTICLE', d.data)
          return
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    createArticle ({commit}, data) {
      return virtualOffice.createArticle(data)
        .then((d) => {
          commit('UPDATE_ARTICLE', d.data)
          return
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    updateArticle ({commit}, data) {
      return virtualOffice.updateArticle(data)
        .then((d) => {
          commit('UPDATE_ARTICLE', d.data)
          return
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    deleteArticle ({commit}, id) {
      return virtualOffice.deleteArticle(id)
        .then((d) => {
          commit('DELETE_ARTICLE', id)
          return
        })
        .catch((e) => {
          console.error(e)
          return
        })
    },
    resetCreateScenario ({commit}) {
      commit('RESET_CREATE_SCN')
    },
    resetDeleteScenario ({commit}) {
      commit('RESET_DELETE_SCN')
    },
    resetReloadScenario ({commit}) {
      commit('RESET_RELOAD_SCN')
    }
  },
  mutations: {
    /* *
       * VO一覧への接続
       * setIntervalによる常時呼び出し
       * */
    CONNECT_VO_BEGIN (state, uri) {
      state.wsVO = new WebSocket(uri)
      state.uri = uri
      state.wsVO.onerror = e => {
        state.isVOConnectList = false
        state.wsVO.close()
      }
      state.wsVO.onclose = e => {
        state.isVOConnectList = false
      }
      state.wsVO.onopen = e => {
        if (state.wsVO.readyState === 1) {
          state.isVOConnectList = true
          state.wsVO.send('[CONNECT]')
        }
      }
      state.wsVO.onmessage = e => {
        const data = JSON.parse(e.data)
        state.userList = _.cloneDeep(data.list)
        state.cbList = _.cloneDeep(data.cblist)
        if (data.createScenario) {
          state.makeScenario = data.createScenario
        }
        if (data.deleteScenario) {
          state.deleteScenario = data.deleteScenario
        }
        if (data.reloadScenario) {
          state.reloadScenario = data.reloadScenario
        }
      }
    },
    CONNECT_VO_END (state) {
      if (state.wsVO != null) {
        state.wsVO.close()
      }
    },
    SEND_VO (state, data) {
      console.log('data: ', data)
      if (state.wsVO.readyState === 1) {
        state.wsVO.send('[SETDATA]' + JSON.stringify(data))
      }
    },
    SEND_VO_RAW (state, data) {
      console.log('data: ', data)
      if (state.wsVO.readyState === 1) {
        state.wsVO.send(data)
      }
    },
    /* *
       * VO一覧への接続
       * setIntervalによる常時呼び出し
       * */
    CONNECT_VOC_BEGIN (state, uri) {
      state.wsVOC = new WebSocket(uri)
      state.uriChat = uri
      state.wsVOC.onerror = e => {
        state.isVOConnectList = false
        state.wsVOC.close()
      }
      state.wsVOC.onclose = e => {
        state.isVOC = false
      }
      state.wsVOC.onopen = e => {
        state.isVOC = true
      }
      state.wsVOC.onmessage = e => {
        const data = JSON.parse(e.data)
        state.chatMessages.push(JSON.parse(data.data))
      }
    },
    CONNECT_VOC_END (state) {
      if (state.wsVOC != null) {
        state.wsVOC.close()
      }
      state.uriChat = ''
    },
    SEND_VOC (state, data) {
      console.log('data: ', data)
      if (state.wsVOC.readyState === 1) {
        state.wsVOC.send('[SENDDATA]' + JSON.stringify(data))
      }
    },
    // VirtualOffice API
    CREATE_VO (state, data) {
      state.virtualOfficeList.push(data)
    },
    GET_VO (state, data) {
      state.virtualOfficeList = data
    },
    DELETE_VO (state, id) {
      for (let i in state.virtualOfficeList) {
        if (state.virtualOfficeList[i].pk == id) {
          state.virtualOfficeList.splice(i, 1)
          return
        }
      }
    },
    // OfficeType API
    CREATE_OT (state, data) {
      for (let i in state.virtualOfficeList) {
        if (state.virtualOfficeList[i].pk == data.virtual_office) {
          state.virtualOfficeList[i].office_type.push(data)
          return
        }
      }
    },
    GET_OT (state, data) {
      for (let i in state.virtualOfficeList) {
        if (state.virtualOfficeList[i].pk == data.virtual_office) {
          state.virtualOfficeList[i].office_type.splice(i, 1, data)
          return
        }
      }
    },
    DELETE_OT (state, id) {
      for (let i in state.virtualOfficeList) {
        if (state.virtualOfficeList[i].pk == id) {
          state.virtualOfficeList[i].office_type.splice(i, 1)
          return
        }
      }
    },
    // VirtualOfficeRoom API
    CREATE_VOR (state, data) {
      for (let i in state.virtualOfficeList) {
        for (let j in state.virtualOfficeList[i].office_type.virtual_office_room) {
          if (state.virtualOfficeList[i].office_type.virtual_office_room[j].pk == data.office) {
            state.virtualOfficeList[i].office_type.virtual_office_room.push(data)
            return
          }
        }
      }
    },
    GET_VOR (state, data) {
      for (let i in state.virtualOfficeList) {
        for (let j in state.virtualOfficeList[i].office_type.virtual_office_room) {
          if (state.virtualOfficeList[i].office_type.virtual_office_room[j].pk == data.office) {
            state.virtualOfficeList[i].office_type.virtual_office_room.splice(j, 1, data)
            return
          }
        }
      }
    },
    DELETE_VOR (state, id) {
      for (let i in state.virtualOfficeList) {
        for (let j in state.virtualOfficeList[i].office_type.virtual_office_room) {
          if (state.virtualOfficeList[i].office_type.virtual_office_room[j].pk == id) {
            state.virtualOfficeList[i].office_type.virtual_office_room.splice(j, 1)
            return
          }
        }
      }
    },
    // TableName API
    CREATE_TN (state, data) {
      for (let i in state.virtualOfficeList) {
        for (let j in state.virtualOfficeList[i].office_type.virtual_office_room) {
          for (let k in state.virtualOfficeList[i].office_type.virtual_office_room[j].table_name) {
            if (state.virtualOfficeList[i].office_type.virtual_office_room[j].table_name[k].pk == data.room) {
              state.virtualOfficeList[i].office_type.virtual_office_room[j].table_name.push(data)
              return
            }
          }
        }
      }
    },
    GET_TN (state, data) {
      for (let i in state.virtualOfficeList) {
        for (let j in state.virtualOfficeList[i].office_type.virtual_office_room) {
          for (let k in state.virtualOfficeList[i].office_type.virtual_office_room[j].table_name) {
            if (state.virtualOfficeList[i].office_type.virtual_office_room[j].table_name[k].pk == data.room) {
              state.virtualOfficeList[i].office_type.virtual_office_room[j].table_name.splice(k, 1, data)
              return
            }
          }
        }
      }
    },
    DELETE_TN (state, id) {
      for (let i in state.virtualOfficeList) {
        for (let j in state.virtualOfficeList[i].office_type.virtual_office_room) {
          for (let k in state.virtualOfficeList[i].office_type.virtual_office_room[j].table_name) {
            if (state.virtualOfficeList[i].office_type.virtual_office_room[j].table_name[k].pk == data.room) {
              state.virtualOfficeList[i].office_type.virtual_office_room[j].table_name.splice(k, 1)
              return
            }
          }
        }
      }
    },
    INIT_VO (state, data) {
      state.virtualOfficeList = data
    },
    SET_ROOM_STS (state, data) {
      state.roomStatus = data
    },
    LOADING_VO (state, flg) {
      if (flg) {
        state.virtualOfficeList = []
      }
      state.isVirtualOfficeLoading = flg
    },
    // ChatRoom API
    CREATE_CR (state, data) {
      state.chatRooms.unshift(data)
    },
    GET_CR (state, data) {
      state.chatRooms = _.uniqBy(data, 'id')
    },
    UPDATE_CR (state, data) {
      let index = state.chatRooms.findIndex()
      state.chatRooms[index].splice(index, 1, data)
    },
    DELETE_CR (state, id) {
      let index = state.chatRooms.findIndex()
      state.chatRooms[index].splice(index, 1)
    },
    // ChatRoomMessage API
    GET_CRM (state, data) {
      state.chatMessages = data
    },
    // Forum 関連 Mutations
    SET_FORUM (state, data){
      state.forums = data
      console.log(data)
    },
    UPDATE_FORUM (state, data) {
      let idx = state.forums.findIndex(f => f.id == data.id)
      if (idx==-1) state.forums.push(data)
      else state.forums.splice(idx, 1, data)
    },
    OPEN_FORUM (state, id) {
      state.openingForum = state.forums.find(f => f.id == id)
    },
    // Article 関連 Mutations
    SET_ARTICLE (state, data) {
      state.articles = data
    },
    UPDATE_ARTICLE (state, data) {
      let idx = state.articles.findIndex(a => a.id == data.id)
      if (idx==-1) state.articles.push(data)
      else state.articles.splice(idx, 1, data)
    },
    DELETE_ARTICLE (state, id) {
      let idx = state.articles.findIndex(a => a.id == data.id)
      if (idx!=-1) state.articles.splice(idx, 1)
    },
    RESET_CREATE_SCN (state) {
      state.createScenario = null
    },
    RESET_DELETE_SCN (state) {
      state.deleteScenario = null
    },
    RESET_RELOAD_SCN (state) {
      state.reloadScenario = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/virtualOffice.js